<template>
  <!--
    PoolaSkeleton — first-load placeholder for the Poola buy screen. A CONTENT
    FRAGMENT (no <f7-page>) mirroring SkeletonCard.vue's f7-skeleton-block wave
    pattern: a run header (title + countdown row) above a couple of offer cards.
    Never flashes a misleading empty/zero (FE plan Section 7).
  -->
  <div class="poola-skeleton">
    <!-- Run header: title + countdown cells -->
    <div class="poola-skeleton__header">
      <f7-skeleton-block
        tag="div"
        width="60%"
        height="22px"
        border-radius="6px"
        effect="wave"
      ></f7-skeleton-block>
      <f7-skeleton-block
        tag="div"
        width="40%"
        height="14px"
        border-radius="4px"
        effect="wave"
        class="poola-skeleton__subtitle"
      ></f7-skeleton-block>
    </div>

    <!-- Offer cards -->
    <div v-for="n in 2" :key="n" class="poola-skeleton__card">
      <f7-skeleton-block
        tag="div"
        width="100%"
        height="180px"
        border-radius="12px"
        effect="wave"
      ></f7-skeleton-block>
      <f7-skeleton-block
        tag="div"
        width="80%"
        height="16px"
        border-radius="4px"
        effect="wave"
        class="poola-skeleton__line"
      ></f7-skeleton-block>
      <f7-skeleton-block
        tag="div"
        width="100%"
        height="12px"
        border-radius="6px"
        effect="wave"
        class="poola-skeleton__line"
      ></f7-skeleton-block>
      <f7-skeleton-block
        tag="div"
        width="100%"
        height="40px"
        border-radius="10px"
        effect="wave"
        class="poola-skeleton__cta"
      ></f7-skeleton-block>
    </div>
  </div>
</template>

<script setup>
// Pure presentation — no props or logic.
</script>

<style scoped>
.poola-skeleton {
  padding: 8px 0 24px;
}

.poola-skeleton__header {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  padding: 24px 20px;
}

.poola-skeleton__subtitle {
  margin-top: 2px;
}

.poola-skeleton__card {
  margin: 0 16px 16px;
  padding: 16px;
  background: var(--poolit-bg-primary);
  border-radius: var(--poolit-radius-lg);
  border: 1px solid var(--poolit-border-color);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.poola-skeleton__line {
  margin: 0;
}

.poola-skeleton__cta {
  margin-top: 4px;
}

/* Inherit the brand skeleton tint + honor reduced-motion (mirror SkeletonCard). */
.poola-skeleton :deep(.skeleton-block) {
  background-color: var(--f7-color-gray-200, #e5e7eb);
}

.dark .poola-skeleton :deep(.skeleton-block) {
  background-color: var(--f7-color-gray-700, #374151);
}

@media (prefers-reduced-motion: reduce) {
  .poola-skeleton :deep(.skeleton-effect-wave::before) {
    animation: none;
  }
}
</style>
